export default __webpack_public_path__ + "static/calendar-b95abe17e2dc2a3540d9a6db62ea5a9f.png";